export default __webpack_public_path__ + "static/mode-multiplayer-7fcf40904d91d3e9982ea27ca680b6b7.png";